// extracted by mini-css-extract-plugin
export default {"cta":"NVWE0ZCd0DUztOJAFuFH","copy":"rGerUyQrUZUGgOomfDsj","button":"wrlWZoP0ruWVfyEMrv6K"};